import axios from '../utils/axios'

// 获取粉丝列表
export function getMyFansList(params) {
  return axios.post('/user/apiUserAh5Service/myFansAndGuestList', params)
}
